/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Admin BFF API
 * Authentication and admin gateway for the AvilaRoffe platform.
 * OpenAPI spec version: 1.0
 */
import type {
  GetTenantsSlugLocalization200,
  GetTenantsSlugStorageConfig200,
  PatchTenantsIdBody,
  PostTenantsBody,
  PutTenantsSlugAvatarBody,
  PutTenantsSlugLocalization200,
  PutTenantsSlugStorageConfig200,
  TenantsErrorResponse,
  TenantsTenantEnvelope,
  TenantsTenantListEnvelope
} from '../adminBFFAPI.schemas';

import { adminBffFetch } from '../../mutator';

/**
 * @summary List all tenants
 */
export type getTenantsResponse200 = {
  data: TenantsTenantListEnvelope
  status: 200
}

export type getTenantsResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type getTenantsResponseSuccess = (getTenantsResponse200) & {
  headers: Headers;
};
export type getTenantsResponseError = (getTenantsResponse500) & {
  headers: Headers;
};

export type getTenantsResponse = (getTenantsResponseSuccess | getTenantsResponseError)

export const getGetTenantsUrl = () => {


  

  return `/tenants`
}

export const getTenants = async ( options?: RequestInit): Promise<getTenantsResponse> => {
  
  return adminBffFetch<getTenantsResponse>(getGetTenantsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Create a new tenant and provision its schema
 */
export type postTenantsResponse201 = {
  data: TenantsTenantEnvelope
  status: 201
}

export type postTenantsResponse400 = {
  data: TenantsErrorResponse
  status: 400
}

export type postTenantsResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type postTenantsResponseSuccess = (postTenantsResponse201) & {
  headers: Headers;
};
export type postTenantsResponseError = (postTenantsResponse400 | postTenantsResponse500) & {
  headers: Headers;
};

export type postTenantsResponse = (postTenantsResponseSuccess | postTenantsResponseError)

export const getPostTenantsUrl = () => {


  

  return `/tenants`
}

export const postTenants = async (postTenantsBody: PostTenantsBody, options?: RequestInit): Promise<postTenantsResponse> => {
  
  return adminBffFetch<postTenantsResponse>(getPostTenantsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postTenantsBody,)
  }
);}


/**
 * @summary Get a tenant by ID or slug, including all app settings overrides
 */
export type getTenantsIdResponse200 = {
  data: TenantsTenantEnvelope
  status: 200
}

export type getTenantsIdResponse404 = {
  data: TenantsErrorResponse
  status: 404
}

export type getTenantsIdResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type getTenantsIdResponseSuccess = (getTenantsIdResponse200) & {
  headers: Headers;
};
export type getTenantsIdResponseError = (getTenantsIdResponse404 | getTenantsIdResponse500) & {
  headers: Headers;
};

export type getTenantsIdResponse = (getTenantsIdResponseSuccess | getTenantsIdResponseError)

export const getGetTenantsIdUrl = (id: string,) => {


  

  return `/tenants/${id}`
}

export const getTenantsId = async (id: string, options?: RequestInit): Promise<getTenantsIdResponse> => {
  
  return adminBffFetch<getTenantsIdResponse>(getGetTenantsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Soft-delete a tenant
 */
export type deleteTenantsIdResponse204 = {
  data: void
  status: 204
}

export type deleteTenantsIdResponse404 = {
  data: TenantsErrorResponse
  status: 404
}

export type deleteTenantsIdResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type deleteTenantsIdResponseSuccess = (deleteTenantsIdResponse204) & {
  headers: Headers;
};
export type deleteTenantsIdResponseError = (deleteTenantsIdResponse404 | deleteTenantsIdResponse500) & {
  headers: Headers;
};

export type deleteTenantsIdResponse = (deleteTenantsIdResponseSuccess | deleteTenantsIdResponseError)

export const getDeleteTenantsIdUrl = (id: string,) => {


  

  return `/tenants/${id}`
}

export const deleteTenantsId = async (id: string, options?: RequestInit): Promise<deleteTenantsIdResponse> => {
  
  return adminBffFetch<deleteTenantsIdResponse>(getDeleteTenantsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * @summary Update a tenant's display name
 */
export type patchTenantsIdResponse200 = {
  data: TenantsTenantEnvelope
  status: 200
}

export type patchTenantsIdResponse400 = {
  data: TenantsErrorResponse
  status: 400
}

export type patchTenantsIdResponse404 = {
  data: TenantsErrorResponse
  status: 404
}

export type patchTenantsIdResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type patchTenantsIdResponseSuccess = (patchTenantsIdResponse200) & {
  headers: Headers;
};
export type patchTenantsIdResponseError = (patchTenantsIdResponse400 | patchTenantsIdResponse404 | patchTenantsIdResponse500) & {
  headers: Headers;
};

export type patchTenantsIdResponse = (patchTenantsIdResponseSuccess | patchTenantsIdResponseError)

export const getPatchTenantsIdUrl = (id: string,) => {


  

  return `/tenants/${id}`
}

export const patchTenantsId = async (id: string,
    patchTenantsIdBody: PatchTenantsIdBody, options?: RequestInit): Promise<patchTenantsIdResponse> => {
  
  return adminBffFetch<patchTenantsIdResponse>(getPatchTenantsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchTenantsIdBody,)
  }
);}


/**
 * @summary Reactivate a suspended tenant
 */
export type postTenantsIdReactivateResponse204 = {
  data: void
  status: 204
}

export type postTenantsIdReactivateResponse404 = {
  data: TenantsErrorResponse
  status: 404
}

export type postTenantsIdReactivateResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type postTenantsIdReactivateResponseSuccess = (postTenantsIdReactivateResponse204) & {
  headers: Headers;
};
export type postTenantsIdReactivateResponseError = (postTenantsIdReactivateResponse404 | postTenantsIdReactivateResponse500) & {
  headers: Headers;
};

export type postTenantsIdReactivateResponse = (postTenantsIdReactivateResponseSuccess | postTenantsIdReactivateResponseError)

export const getPostTenantsIdReactivateUrl = (id: string,) => {


  

  return `/tenants/${id}/reactivate`
}

export const postTenantsIdReactivate = async (id: string, options?: RequestInit): Promise<postTenantsIdReactivateResponse> => {
  
  return adminBffFetch<postTenantsIdReactivateResponse>(getPostTenantsIdReactivateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Restore a soft-deleted tenant
 */
export type postTenantsIdRestoreResponse204 = {
  data: void
  status: 204
}

export type postTenantsIdRestoreResponse404 = {
  data: TenantsErrorResponse
  status: 404
}

export type postTenantsIdRestoreResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type postTenantsIdRestoreResponseSuccess = (postTenantsIdRestoreResponse204) & {
  headers: Headers;
};
export type postTenantsIdRestoreResponseError = (postTenantsIdRestoreResponse404 | postTenantsIdRestoreResponse500) & {
  headers: Headers;
};

export type postTenantsIdRestoreResponse = (postTenantsIdRestoreResponseSuccess | postTenantsIdRestoreResponseError)

export const getPostTenantsIdRestoreUrl = (id: string,) => {


  

  return `/tenants/${id}/restore`
}

export const postTenantsIdRestore = async (id: string, options?: RequestInit): Promise<postTenantsIdRestoreResponse> => {
  
  return adminBffFetch<postTenantsIdRestoreResponse>(getPostTenantsIdRestoreUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Suspend a tenant
 */
export type postTenantsIdSuspendResponse204 = {
  data: void
  status: 204
}

export type postTenantsIdSuspendResponse404 = {
  data: TenantsErrorResponse
  status: 404
}

export type postTenantsIdSuspendResponse500 = {
  data: TenantsErrorResponse
  status: 500
}
    
export type postTenantsIdSuspendResponseSuccess = (postTenantsIdSuspendResponse204) & {
  headers: Headers;
};
export type postTenantsIdSuspendResponseError = (postTenantsIdSuspendResponse404 | postTenantsIdSuspendResponse500) & {
  headers: Headers;
};

export type postTenantsIdSuspendResponse = (postTenantsIdSuspendResponseSuccess | postTenantsIdSuspendResponseError)

export const getPostTenantsIdSuspendUrl = (id: string,) => {


  

  return `/tenants/${id}/suspend`
}

export const postTenantsIdSuspend = async (id: string, options?: RequestInit): Promise<postTenantsIdSuspendResponse> => {
  
  return adminBffFetch<postTenantsIdSuspendResponse>(getPostTenantsIdSuspendUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


/**
 * @summary Upload an avatar image for a tenant
 */
export type putTenantsSlugAvatarResponse200 = {
  data: TenantsTenantEnvelope
  status: 200
}

export type putTenantsSlugAvatarResponse400 = {
  data: TenantsErrorResponse
  status: 400
}

export type putTenantsSlugAvatarResponse503 = {
  data: TenantsErrorResponse
  status: 503
}
    
export type putTenantsSlugAvatarResponseSuccess = (putTenantsSlugAvatarResponse200) & {
  headers: Headers;
};
export type putTenantsSlugAvatarResponseError = (putTenantsSlugAvatarResponse400 | putTenantsSlugAvatarResponse503) & {
  headers: Headers;
};

export type putTenantsSlugAvatarResponse = (putTenantsSlugAvatarResponseSuccess | putTenantsSlugAvatarResponseError)

export const getPutTenantsSlugAvatarUrl = (slug: string,) => {


  

  return `/tenants/${slug}/avatar`
}

export const putTenantsSlugAvatar = async (slug: string,
    putTenantsSlugAvatarBody: PutTenantsSlugAvatarBody, options?: RequestInit): Promise<putTenantsSlugAvatarResponse> => {
    const formData = new FormData();
formData.append(`file`, putTenantsSlugAvatarBody.file)

  return adminBffFetch<putTenantsSlugAvatarResponse>(getPutTenantsSlugAvatarUrl(slug),
  {      
    ...options,
    method: 'PUT'
    ,
    body: 
      formData,
  }
);}


/**
 * @summary Get tenant localization settings
 */
export type getTenantsSlugLocalizationResponse200 = {
  data: GetTenantsSlugLocalization200
  status: 200
}
    
export type getTenantsSlugLocalizationResponseSuccess = (getTenantsSlugLocalizationResponse200) & {
  headers: Headers;
};
;

export type getTenantsSlugLocalizationResponse = (getTenantsSlugLocalizationResponseSuccess)

export const getGetTenantsSlugLocalizationUrl = (slug: string,) => {


  

  return `/tenants/${slug}/localization`
}

export const getTenantsSlugLocalization = async (slug: string, options?: RequestInit): Promise<getTenantsSlugLocalizationResponse> => {
  
  return adminBffFetch<getTenantsSlugLocalizationResponse>(getGetTenantsSlugLocalizationUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Create or update tenant localization settings
 */
export type putTenantsSlugLocalizationResponse200 = {
  data: PutTenantsSlugLocalization200
  status: 200
}
    
export type putTenantsSlugLocalizationResponseSuccess = (putTenantsSlugLocalizationResponse200) & {
  headers: Headers;
};
;

export type putTenantsSlugLocalizationResponse = (putTenantsSlugLocalizationResponseSuccess)

export const getPutTenantsSlugLocalizationUrl = (slug: string,) => {


  

  return `/tenants/${slug}/localization`
}

export const putTenantsSlugLocalization = async (slug: string, options?: RequestInit): Promise<putTenantsSlugLocalizationResponse> => {
  
  return adminBffFetch<putTenantsSlugLocalizationResponse>(getPutTenantsSlugLocalizationUrl(slug),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}


/**
 * @summary Get tenant storage configuration
 */
export type getTenantsSlugStorageConfigResponse200 = {
  data: GetTenantsSlugStorageConfig200
  status: 200
}
    
export type getTenantsSlugStorageConfigResponseSuccess = (getTenantsSlugStorageConfigResponse200) & {
  headers: Headers;
};
;

export type getTenantsSlugStorageConfigResponse = (getTenantsSlugStorageConfigResponseSuccess)

export const getGetTenantsSlugStorageConfigUrl = (slug: string,) => {


  

  return `/tenants/${slug}/storage-config`
}

export const getTenantsSlugStorageConfig = async (slug: string, options?: RequestInit): Promise<getTenantsSlugStorageConfigResponse> => {
  
  return adminBffFetch<getTenantsSlugStorageConfigResponse>(getGetTenantsSlugStorageConfigUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Create or update tenant storage configuration
 */
export type putTenantsSlugStorageConfigResponse200 = {
  data: PutTenantsSlugStorageConfig200
  status: 200
}
    
export type putTenantsSlugStorageConfigResponseSuccess = (putTenantsSlugStorageConfigResponse200) & {
  headers: Headers;
};
;

export type putTenantsSlugStorageConfigResponse = (putTenantsSlugStorageConfigResponseSuccess)

export const getPutTenantsSlugStorageConfigUrl = (slug: string,) => {


  

  return `/tenants/${slug}/storage-config`
}

export const putTenantsSlugStorageConfig = async (slug: string, options?: RequestInit): Promise<putTenantsSlugStorageConfigResponse> => {
  
  return adminBffFetch<putTenantsSlugStorageConfigResponse>(getPutTenantsSlugStorageConfigUrl(slug),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}


/**
 * @summary Remove tenant storage configuration
 */
export type deleteTenantsSlugStorageConfigResponse204 = {
  data: void
  status: 204
}
    
export type deleteTenantsSlugStorageConfigResponseSuccess = (deleteTenantsSlugStorageConfigResponse204) & {
  headers: Headers;
};
;

export type deleteTenantsSlugStorageConfigResponse = (deleteTenantsSlugStorageConfigResponseSuccess)

export const getDeleteTenantsSlugStorageConfigUrl = (slug: string,) => {


  

  return `/tenants/${slug}/storage-config`
}

export const deleteTenantsSlugStorageConfig = async (slug: string, options?: RequestInit): Promise<deleteTenantsSlugStorageConfigResponse> => {
  
  return adminBffFetch<deleteTenantsSlugStorageConfigResponse>(getDeleteTenantsSlugStorageConfigUrl(slug),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


